import { OurNode } from "@src/cloud-connect/poc/our-node";

export class TransportConfigurationToClientPayloadBuilder {
  private clientId: string;
  private name: string;
  private rootNode: OurNode;

  constructor(clientId: string, name: string, rootNode: OurNode) {
    this.clientId = clientId;
    this.name = name;
    this.rootNode = rootNode;
  }

  build() {
    return {
      client_id: this.clientId,
      source_type: this.rootNode.source_type,
      name: this.name,
      root_node: this.rootNode.toServerChildrenObjectTree(),
    };
  }
}
